<div class="p-grid">
  @if (isEditable && !task.id) {
    <div class="col-12"
      style="margin-top: 11px;">
      <ng-select
        class="custom"
        required
        [items]="templateOptions"
        placeholder="Select a Task Template"
        [selectOnTab]="true"
        name="task"
        bindLabel="name"
        (change)="onTemplateSelect($event)"
        >
      </ng-select>
    </div>
  }
</div>
<form class="p-grid" id="workTaskForm" #workTaskForm="ngForm">
  @if (canChangeStatus) {
    <div class="col-12">
      <label>Status</label>
      <ng-select
        class="custom"
        [items]="statuses"
        name="status"
        [clearable]="false"
        [(ngModel)]="task.completionStatus"
      ></ng-select>
    </div>
  }
  @if (canChangeStatus && task.completionStatus != 'Completed') {
    <div class="col-12">
      <label>Customer's Issue</label>
      <textarea
        pInputTextarea
        [(ngModel)]="task.customerIssue"
        [rows]="3"
        name="customerIssue"
        style="width: 100%;"
        required
        placeholder=""
      ></textarea>
    </div>
  }
  @if (canChangeStatus && (task.completionStatus == 'Go Back' || isIncompleteGoBack)) {
    <div class="col-12">
      <label>Hours (For Go Back)</label>
      @if (task) {
        <input pInputText
          fluid
          name="goBackHours"
          required
          [(ngModel)]="task.goBackHoursEstimate"
          />
      }
    </div>
  }
  @if (canChangeStatus && (task.completionStatus == 'Go Back' || isIncompleteGoBack)) {
    <div class="col-12">
      <label>Required Equipment (For Go Back)</label>
      @if (task) {
        <ng-select
          name="goBackEquipment"  
          class="multi-custom"
          [items]="goBackEquipmentOptions"
          [multiple]="true"
          [closeOnSelect]="false"
          [searchable]="true"
          [clearSearchOnAdd]="true" 
          placeholder="Choose"
          [(ngModel)]="task.workTaskGoBackEquipment"
          [required]="true"
          [searchFn]="equipmentSearchFn"
        >
          <ng-template ng-label-tmp let-item="item">
            <div>
              <span>{{item.equipmentType.type}}</span>
            </div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
            <span>{{ item.equipmentType.type }}</span>
          </ng-template>
        </ng-select>
      }
    </div>
  }
  @if (canChangeStatus && (task.completionStatus == 'Go Back' || isIncompleteGoBack)) {
    <div class="col-12">
      <label>Uploads (For Go Back)</label>
      <app-blob-manager [angularUpload]="true"
        [containerName]="'work-task-go-back'"
        [parentRecordId]="uploadId"
        [uploadLabel]="'Document/Photo'"
        [viewOnly]="!canEditUploads">
      </app-blob-manager>
    </div>
  }
  <div class="col-12">
    <p-card>
      <div class="p-grid">
        <div class="col-6">
          <h6>Task Name</h6>
          @if (task) {
            <input pInputText
              name="name"
              fluid
              [(ngModel)]="task.name"
              [disabled]="!isEditable"
              required />
          }
        </div>
        <div class="col-6" style="text-align: left; margin-top: auto">
          @if (task) {
            <p-radiobutton
              name="permissionRequired"
              [value]="true"
              [(ngModel)]="task.fixedPrice"
              [disabled]="!isEditable"
              required
              >
            </p-radiobutton>
            <label for="permissionRequired">Fixed Price</label>
            }<br/>
            @if (task) {
              <p-radiobutton
                name="permissionNotRequired"
                [value]="false"
                [(ngModel)]="task.fixedPrice"
                [disabled]="!isEditable"
                required
                >
              </p-radiobutton>
              <label for="permissionNotRequired">Crew Hourly Rate</label>
            }
          </div>
          <!-- Begin text boxes for fixed price option -->
          @if (task.fixedPrice) {
            <div class="col-6">
              <h6>Price</h6>
              @if (task) {
                <app-no-decimal-input 
                  [name]="'price'" 
                  [isRequired]="true" 
                  [isDisabled]="!isEditable || isInvoiced" 
                  [value]="task.price"
                  (emitResult)="task.price=$event"
                ></app-no-decimal-input>
              }
            </div>
          }
          @if (task.fixedPrice) {
            <div class="col-6">
              <h6>Hours Estimate</h6>
              @if (task) {
                <input pInputText
                  fluid
                  name="hours"
                  required
                  inputmode="decimal"
                  [(ngModel)]="task.hours"
                  [disabled]="!isEditable" />
              }
            </div>
          }
          <!-- Begin text boxes for hourly price option -->
          @if (!task.fixedPrice) {
            <div class="col-6">
              <h6>Crew Hourly Rate</h6>
              @if (task) {
                <app-no-decimal-input 
                    type="number" 
                    pattern="[0-9]*" 
                    inputmode="numeric"
                    [name]="'hourlyRate'" 
                    [isRequired]="true" 
                    [isDisabled]="isInvoiced" 
                    [value]="task.hourlyRate"
                    (emitResult)="task.hourlyRate=$event"
                ></app-no-decimal-input>
              }
            </div>
          }
          @if (!task.fixedPrice) {
            <div class="col-6"><!-- Spacer --></div>
          }
          @if (!task.fixedPrice) {
            <div class="col-6">
              <h6>Minimum Price</h6>
              @if (task) {
                <app-no-decimal-input 
                  type="number" 
                  pattern="[0-9]*" 
                  inputmode="numeric"
                  [name]="'minPrice'" 
                  [isRequired]="true" 
                  [isDisabled]="isInvoiced" 
                  [value]="task.minPrice"
                  (emitResult)="task.minPrice=$event"
                ></app-no-decimal-input>
              }
            </div>
          }
          @if (!task.fixedPrice) {
            <div class="col-6">
              <h6>Maximum Price</h6>
              @if (task) {
                <app-no-decimal-input 
                  type="number" 
                  pattern="[0-9]*" 
                  inputmode="numeric"
                  [name]="'maxPrice'" 
                  [isRequired]="false" 
                  [isDisabled]="isInvoiced" 
                  [value]="task.maxPrice"
                  (emitResult)="task.maxPrice=$event"
                ></app-no-decimal-input>
              }
            </div>
          }
          <!-- End sections related to fixed/hourly costs -->
          <div class="col-12 columnPadding topMargin">
            <h6>Description</h6>
            @if (task) {
              <textarea pInputTextarea
                fluid
                name="description"
                required
                class="form-control"
                [(ngModel)]="task.description"
                [rows]="8"
                style="width: 100%;"
                [disabled]="!isEditable">
              </textarea>
            }
          </div>
        </div>
      </p-card>
    </div>
    <div class="col-12 multiSelect">
      <h6>Tree Type(s)</h6>
      @if (task) {
        <ng-select
          name="treeTypes"  
          class="multi-custom"
          [items]="treeTypeOptions"
          [multiple]="true"
          [closeOnSelect]="false"
          [searchable]="true"
          [clearSearchOnAdd]="true" 
          placeholder="Choose"
          [(ngModel)]="task.workTaskTreeTypes"
          [disabled]="!isEditable || limitEditing"
          [required]="true"
          [searchFn]="treeTypeSearchFn"
        >
          <ng-template ng-label-tmp let-item="item">
            <div>
                @if (item.treeType) {
                  <span>{{item.treeType.commonName}}</span>
                }
                @if (!item.treeType) {
                  <span>Unknown</span>
                }
              </div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
            <span>{{ item.treeType?.label }}</span>
          </ng-template>
        </ng-select>
      }
    </div>
    <div class="col-12">
      <h6>Location of Tree(s)</h6>
      @if (task) {
        <textarea pInputTextarea
          fluid
          [(ngModel)]="task.location"
          [disabled]="!isEditable"
          class="form-control"
          [rows]="2"
          name="location"
          style="width: 100%;"
          required
          >
        </textarea>
      }
    </div>
    <div class="col-12 multiSelect">
      <h6>Required Skill(s)/Certification(s)</h6>
      @if (task) {
        <ng-select
          name="skills"  
          class="multi-custom"
          [items]="skillOptions"
          [multiple]="true"
          [closeOnSelect]="false"
          [searchable]="true"
          [clearSearchOnAdd]="true" 
          placeholder="Choose"
          [(ngModel)]="task.workTaskSkills"
          [disabled]="!isEditable || limitEditing"
          [searchFn]="skillSearchFn"
        >
          <ng-template ng-label-tmp let-item="item">
            <div>
              <span>{{item.skill.name}}</span>
            </div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
            <span>{{ item.skill.name }}</span>
          </ng-template>
        </ng-select>
      }
    </div>
    <div class="col-12 multiSelect">
      <h6>Required Equipment Type(s)</h6>
      @if (task) {
        <ng-select
          name="equipment"  
          class="multi-custom"
          [items]="equipmentOptions"
          [multiple]="true"
          [closeOnSelect]="false"
          [searchable]="true"
          [clearSearchOnAdd]="true" 
          placeholder="Choose"
          [(ngModel)]="task.workTaskEquipment"
          [disabled]="!isEditable || limitEditing"
          [searchFn]="equipmentSearchFn"
        >
          <ng-template ng-label-tmp let-item="item">
            <div>
              <span>{{item.equipmentType.type}}</span>
            </div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
            <span>{{ item.equipmentType.type }}</span>
          </ng-template>
        </ng-select>
      }
    </div>
    <div class="col-12">
      <h6>Schedulable After The Completion Of:</h6>
      @if (task) {
        <ng-select
          class="custom"
          [items]="dependencyOptions"
          [disabled]="!isEditable"
          placeholder="Does this task require another task to be completed first?"
          name="SchedulableAfterCompletionOf"
          bindLabel="name"
          [selectOnTab]="true"
          bindValue="id"
          (change)="onSchedulableAfterCompletionOfIdChange()"
          [(ngModel)]="task.schedulableAfterCompletionOfId"
          >
        </ng-select>
      }
    </div>
    <div class="col-12">
      <h6>Priority</h6>
      @if (!refreshPriority) {
        <app-priority-and-date-selector
          #prioritySelector
          [(taskOrQuote)]="task"
          [isEditable]="isEditable"
          [showRangeCalculationOption]="showRangeCalculationOption">
        </app-priority-and-date-selector>
      }
      <app-loading-swirly [isLoading]="refreshPriority"></app-loading-swirly>
    </div>
    <div class="col-12">
      <h6>Uploads:</h6>
      <app-blob-manager [angularUpload]="true"
        [containerName]="'work-task'"
        [parentRecordId]="uploadId"
        [uploadLabel]="'Document/Photo'"
        [viewOnly]="!canEditUploads">
      </app-blob-manager>
    </div>

    @if (!isQuoteTask && !task.id || task.customerSignature) {
      <span>
        <app-legal-acceptance-verbiage [paymentDueOption]="workOrder.paymentDueOption" [customerType]="workOrder.customer.customerTypeId"></app-legal-acceptance-verbiage>
        <br/>
        <app-signature-area
          [signature]="task.customerSignature"
          [isAlwaysDisabled]="task.id"
          [name]="'Customer'"
          (currentSignature)="onUpdatedSignature($event)"
          >
        </app-signature-area>
      </span>
    }
    <div class="col-12 columnPadding">
      @if (workTaskForm.invalid && workTaskForm.submitted) {
        <div class="alert alert-danger" role="alert">
          There are errors on this page. Please correct the errors and resubmit.
        </div>
      }
      @if (showSignError) {
        <div class="alert alert-danger" role="alert">
          Please have the customer sign above.
        </div>
      }
    </div>
    <div class="col-12">
      <div class="p-grid">
        <div class="col-12 columnPadding" style="text-align: right;">
          @if (isEditable && task.id) {
            <p-button 
              type="button"
              severity="danger"
              (click)="deleteButtonPressed()"
              label="Delete"
              [disabled]="isInvoiced"
              >
            </p-button>
          }
          <p-button 
            type="button"
            severity="warn"
            (click)="cancelButtonPressed()"
            label="Cancel">
          </p-button>
          <p-button 
            type="submit"
            severity="success"
            (click)="saveTask(workTaskForm)"
            [disabled]="(!isEditable || isSaving) && !canChangeStatus"
            label=" Save">
          </p-button>
        </div>
      </div>
    </div>
  </form>